import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import moment from "moment";

import {
	IFiltersReducerState,
	IGetEventLogsRequestData,
	ITimeFilter,
	LogFilterType,
	TIME_RANGE_OPTIONS_E
} from "../../types";
import { API_TIMESTAMP_FORMAT } from "../../utils/constants";

const initialState: IFiltersReducerState = {
	timeRange: TIME_RANGE_OPTIONS_E.TODAY,
	timeFilter: {
		start_time: moment().startOf("day").format(API_TIMESTAMP_FORMAT.TIME_FILTER),
		end_time: moment().endOf("day").format(API_TIMESTAMP_FORMAT.TIME_FILTER)
	},
	eventLogsType: null,
	eventLogsFilters: {
		page: 1,
		page_size: 20,
		timestamp__gte: moment().startOf("day").format(API_TIMESTAMP_FORMAT.TIME_FILTER),
		timestamp__lte: moment().endOf("day").format(API_TIMESTAMP_FORMAT.TIME_FILTER)
	}
};

const filtersReducer = createSlice({
	name: "filters",
	initialState: initialState,
	reducers: {
		setEventLogsFilters: (state, { payload }: PayloadAction<IGetEventLogsRequestData>) => {
			state.eventLogsFilters = payload;
		},

		setEventLogsType: (state, { payload }: PayloadAction<LogFilterType | null>) => {
			state.eventLogsType = payload;
		},

		setTimeFilter: (state, { payload }: PayloadAction<ITimeFilter>) => {
			state.timeFilter = payload;
		},

		setTimeRange: (state, { payload }: PayloadAction<TIME_RANGE_OPTIONS_E>) => {
			state.timeRange = payload;
		},

		resetAllFilters: (state) => {
			state.timeRange = initialState.timeRange;
			state.timeFilter = initialState.timeFilter;
			state.eventLogsType = initialState.eventLogsType;
			state.eventLogsFilters = initialState.eventLogsFilters;
		}
	}
});

export const { setEventLogsFilters, setEventLogsType, setTimeFilter, setTimeRange, resetAllFilters } =
	filtersReducer.actions;

export default filtersReducer;
